<ion-input
	readonly
	name="dynamicFormControl.key"
	[value]="formulaResult"
	[ngClass]="{
		'error-class':
			form.get(dynamicFormControl.key).invalid &&
			(form.get(dynamicFormControl.key).dirty || form.get(dynamicFormControl.key).touched),
		'disabled-class': dynamicFormControl.disabled
	}"
></ion-input>
<ion-button [id]="dynamicFormControl.key" fill="clear" class="ion-no-margin" size="small"> i </ion-button>
<ion-note *ngIf="formulaResultErrorMessage">
	{{ formulaResultErrorMessage }}
</ion-note>

<ion-popover
	class="calculated-formula"
	[trigger]="dynamicFormControl.key"
	side="top"
	alignment="right"
	size="auto"
	triggerAction="click"
>
	<ng-template>
		<ion-content class="ion-padding">{{ dynamicFormControl.formulaToCalculate }}</ion-content>
	</ng-template>
</ion-popover>
